import WarningIcon from '@mui/icons-material/Warning';
import { SxProps, Theme } from '@mui/material';
import { TypographyVariant } from '@mui/material/styles/createTypography';

import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { Box } from '../Box/Box';
import { Button } from '../Button/Button';
import { Typography } from '../Typography/Typography';

export interface ErrorBoundaryFallbackProps {
  title: string;
  onRefresh?: () => void;
  sx?: SxProps<Theme>;
  /**
   * @default 'h3'
   */
  titleVariant?: TypographyVariant;
}

export const ErrorBoundaryFallback = (props: ErrorBoundaryFallbackProps): React.ReactElement => {
  const { title, onRefresh, sx, titleVariant } = props;
  return (
    <Box
      sx={[
        (theme) => ({
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          position: 'absolute',
          height: '100%',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center'
        }),
        ...toSxArray(sx)
      ]}>
      <WarningIcon fontSize='large' color='error' />
      <Typography variant={titleVariant || 'h3'} text={title} />
      {onRefresh && <Button variant='outlined' onClick={onRefresh} text={'Click to Reload'} />}
    </Box>
  );
};
